import axiosInstance from "../Interceptor";
import axios from "axios";

export const getCustomerListApi = (data) => {
 

  const baseUrl = process.env.REACT_APP_BASE_URL_TWO;
  if (data > 1) {
    return axiosInstance
      .get(`orders/api/v1/orders/regional_admin/users/?page=${data}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
      
        return err;
      });
  } else {
    return axiosInstance
      .get(`orders/api/v1/orders/regional_admin/${data}/`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        
        return err;
      });
  }
};
